import type { FaireProductEntity } from "../../entity_types/product";

export const p_3ew3m2z58k: FaireProductEntity = {
  token: "p_3ew3m2z58k",
  type: "product",
  name: "Elephants On Parade Rayon Harem Pants",
  brandToken: "b_5xdelgfsdc",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4c1426fcd48fc61cb0a4bb19a7a32b1e657ec6581ffa73efca820c1bc2102809.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/470aeda06cc755bf52c40de5ab26f1f76e3bb5b3416df0c852fbe71b64b67d90.png",
  ],
  priceDollars: 16.28,
  description:
    'Get ready to join the parade of style and embrace the vibrant energy of our "Elephants On Parade Rayon Harem Pants." These pants are a delightful fusion of comfort, creativity, and the majestic spirit of elephants. Each pair is a kaleidoscope of colors and patterns, making each purchase a unique surprise with assorted variations that embody the spirit of bohemian freedom. Handcrafted with care from soft and flowing rayon fabric, these pants offer a luxurious feel against your skin, allowing you to move with grace and express your individuality. The vibrant and playful elephant prints celebrate the wisdom and power of these gentle giants, bringing a touch of whimsy and positivity to your wardrobe. With their relaxed harem-style fit and elastic waistband, these pants provide all-day comfort and versatility, allowing you to dance, lounge, or explore with ease. \n\n\n',
  tags: [],
  msrpDollars: 32.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:19.282Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
